import {createGlobalStyle, css} from 'styled-components'
import {minWidth, maxWidth} from 'core/theme'
import {rem} from 'polished'
import './../../../../sass/etr/scss/base/_font-face.scss'

const ResetStyles = css`
  /*! normalize.css v4.0.0 | MIT License | github.com/necolas/normalize.css */

  /**
   * 1. Change the default font family in all browsers (opinionated).
   * 2. Prevent adjustments of font size after orientation changes in IE and iOS.
   */
  html {
    font-family: sans-serif; /* 1 */
    -ms-text-size-adjust: 100%; /* 2 */
    -webkit-text-size-adjust: 100%; /* 2 */
  }

  /**
 * Remove the margin in all browsers (opinionated).
 */
  body {
    margin: 0;
  }

  /* HTML5 display definitions
   ========================================================================== */

  /**
   * Add the correct display in IE 9-.
   * 1. Add the correct display in Edge, IE, and Firefox.
   * 2. Add the correct display in IE.
   */
  article,
  aside,
  details, /* 1 */
  figcaption,
  figure,
  footer,
  header,
  main, /* 2 */
  menu,
  nav,
  section,
  summary { /* 1 */
    display: block;
  }

  /**
   * Add the correct display in IE 9-.
   */
  audio,
  canvas,
  progress,
  video {
    display: inline-block;
  }

  /**
   * Add the correct display in iOS 4-7.
   */
  audio:not([controls]) {
    display: none;
    height: 0;
  }

  /**
   * Add the correct vertical alignment in Chrome, Firefox, and Opera.
   */
  progress {
    vertical-align: baseline;
  }

  /**
   * Add the correct display in IE 10-.
   * 1. Add the correct display in IE.
   */
  template, /* 1 */
  [hidden] {
    display: none;
  }

  /* Links
     ========================================================================== */

  /**
   * Remove the gray background on active links in IE 10.
   */
  a {
    background-color: transparent;
  }

  /**
   * Remove the outline on focused links when they are also active or hovered
   * in all browsers (opinionated).
   */
  a:active,
  a:hover {
    outline-width: 0;
  }

  /* Text-level semantics
     ========================================================================== */

  /**
   * 1. Remove the bottom border in Firefox 39-.
   * 2. Add the correct text decoration in Chrome, Edge, IE, Opera, and Safari.
   */
  abbr[title] {
    border-bottom: none; /* 1 */
    text-decoration: underline; /* 2 */
    text-decoration: underline dotted; /* 2 */
  }

  /**
   * Prevent the duplicate application of \`bolder\` by the next rule in Safari 6.
   */
  b,
  strong {
    font-weight: inherit;
  }

  /**
   * Add the correct font weight in Chrome, Edge, and Safari.
   */
  b,
  strong {
    font-weight: bolder;
  }

  /**
   * Add the correct font style in Android 4.3-.
   */
  dfn {
    font-style: italic;
  }

  /**
   * Add the correct background and color in IE 9-.
   */
  mark {
    background-color: #ff0;
    color: #000;
  }

  /**
   * Add the correct font size in all browsers.
   */
  small {
    font-size: 80%;
  }

  /**
   * Prevent \`sub\` and \`sup\` elements from affecting the line height in
   * all browsers.
   */
  sub, sup {
    font-size: 75%;
    line-height: 0;
    position: relative;
    vertical-align: baseline;
  }
  sub {
    bottom: -0.25em;
  }
  sup {
    top: -0.5em;
  }

  /* Embedded content
     ========================================================================== */

  /**
   * Remove the border on images inside links in IE 10-.
   */
  img {
    border-style: none;
  }

  /**
   * Hide the overflow in IE.
   */
  svg:not(:root) {
    overflow: hidden;
  }

  /* Grouping content
     ========================================================================== */

  /**
   * 1. Correct the inheritance and scaling of font size in all browsers.
   * 2. Correct the odd \`em\` font sizing in all browsers.
   */
  code, kbd, pre, samp {
    font-family: monospace, monospace; /* 1 */
    font-size: 1em; /* 2 */
  }

  /**
   * Add the correct margin in IE 8.
   */
  figure {
    margin: 1em 40px;
  }

  /**
   * 1. Add the correct box sizing in Firefox.
   * 2. Show the overflow in Edge and IE.
   */
  hr {
    box-sizing: content-box; /* 1 */
    height: 0; /* 1 */
    overflow: visible; /* 2 */
  }

  /* Forms
     ========================================================================== */

  /**
   * Change font properties to \`inherit\` in all browsers (opinionated).
   */
  button, input, select, textarea {
    font: inherit;
  }

  /**
   * Restore the font weight unset by the previous rule.
   */
  optgroup {
    font-weight: bold;
  }

  /**
   * Show the overflow in IE.
   * 1. Show the overflow in Edge.
   * 2. Show the overflow in Edge, Firefox, and IE.
   */
  button,
  input, /* 1 */
  select { /* 2 */
    overflow: visible;
  }

  /**
   * Remove the margin in Safari.
   * 1. Remove the margin in Firefox and Safari.
   */
  button,
  input,
  select,
  textarea { /* 1 */
    margin: 0;
  }

  /**
   * Remove the inheritence of text transform in Edge, Firefox, and IE.
   * 1. Remove the inheritence of text transform in Firefox.
   */
  button,
  select { /* 1 */
    text-transform: none;
  }

  /**
   * Change the cursor in all browsers (opinionated).
   */
  button,
  [type="button"],
  [type="reset"],
  [type="submit"] {
    cursor: pointer;
  }

  /**
   * Restore the default cursor to disabled elements unset by the previous rule.
   */
  [disabled] {
    cursor: default;
  }

  /**
   * 1. Prevent a WebKit bug where (2) destroys native \`audio\` and \`video\`
   *    controls in Android 4.
   * 2. Correct the inability to style clickable types in iOS.
   */
  button,
  html [type="button"], /* 1 */
  [type="reset"],
  [type="submit"] {
    -webkit-appearance: button; /* 2 */
  }

  /**
   * Remove the inner border and padding in Firefox.
   */
  button::-moz-focus-inner,
  input::-moz-focus-inner {
    border: 0;
    padding: 0;
  }

  /**
   * Restore the focus styles unset by the previous rule.
   */
  button:-moz-focusring,
  input:-moz-focusring {
    outline: 1px dotted ButtonText;
  }

  /**
   * Change the border, margin, and padding in all browsers (opinionated).
   */
  fieldset {
    border: 1px solid #c0c0c0;
    margin: 0 2px;
    padding: 0.35em 0.625em 0.75em;
  }

  /**
   * 1. Correct the text wrapping in Edge and IE.
   * 2. Correct the color inheritance from \`fieldset\` elements in IE.
   * 3. Remove the padding so developers are not caught out when they zero out
   *    \`fieldset\` elements in all browsers.
   */
  legend {
    box-sizing: border-box; /* 1 */
    color: inherit; /* 2 */
    display: table; /* 1 */
    max-width: 100%; /* 1 */
    padding: 0; /* 3 */
    white-space: normal; /* 1 */
  }

  /**
   * Remove the default vertical scrollbar in IE.
   */
  textarea {
    overflow: auto;
  }

  /**
   * 1. Add the correct box sizing in IE 10-.
   * 2. Remove the padding in IE 10-.
   */
  [type="checkbox"],
  [type="radio"] {
    box-sizing: border-box; /* 1 */
    padding: 0; /* 2 */
  }

  /**
   * Correct the cursor style of increment and decrement buttons in Chrome.
   */
  [type="number"]::-webkit-inner-spin-button,
  [type="number"]::-webkit-outer-spin-button {
    height: auto;
  }

  /**
   * Correct the odd appearance of search inputs in Chrome and Safari.
   */
  [type="search"] {
    -webkit-appearance: textfield;
  }

  /**
   * Remove the inner padding and cancel buttons in Chrome on OS X and
   * Safari on OS X.
   */
  [type="search"]::-webkit-search-cancel-button,
  [type="search"]::-webkit-search-decoration {
    -webkit-appearance: none;
  }
`

const DefaultStyles = css`
  html,
  body {
    ${props => props.theme.typography.latoReg};
    font-size: 16px;
  }
  body {
    background: white;
    color: ${props => props.theme.colors.pepper};
    font-weight: 400;
    line-height: 1.4;
  }
  h1, .h1,
  h2, .h2,
  h3, .h3,
  h4, .h4,
  h5, .h5,
  h6, .h6 {
    ${props => props.theme.typography.latoReg};
  }
  h3, .h3,
  h4, .h4 {
    line-height: 1.28;
    font-size: ${rem(25)};
  }
  h5, .h5,
  h6, .h6 {
    line-height: 1.31;
    font-size: ${rem(16)};
  }
  h1, .h1 {
    line-height: 1.12;
    font-size: ${rem(39)};
  }
  h2, .h2 {
    line-height: 1.19;
    font-size: ${rem(31)};
  }
  p, a {
    line-height: ${rem(21)};
    font-size: ${rem(16)};
  }
  a {
    color: ${props => props.theme.colors.mercuryBlue};
    text-decoration: none;
  }
  p {
    margin-top: 10px;
    margin-bottom: 10px;
    &:empty {
      display: none;
    }
  }
  strong {
    font-weight: 700;
  }
  img {
    max-width: 100%;
    height: auto;
    vertical-align: middle;
  }
  svg {
    fill: currentColor;
  }
  ${minWidth.medium`
    h1,
    .h1 {
      line-height: 1.14;
      font-size: ${rem(61)};
    }
    h2, .h2 {
      line-height: 1.12;
      font-size: ${rem(39)};
    }
    h3, .h3 {
      line-height: 1.19;
      font-size: ${rem(31)};
    }
    h4, .h4 {
      line-height: 1.28;
      font-size: ${rem(25)};
    }
    h5, .h5,
    h6, .h6 {
      line-height: 1.31;
      font-size: ${rem(16)};
    }
  `}
`
const Gigya = css`
  @media (max-width: 450px) {
    .gigya-screen {
      max-width: 334px;
      margin: auto !important;
    }
  }
  .gigya-style-legacy .gigya-screen-dialog {
    border-radius: 4px !important;
    border: none !important;
    box-shadow: 0 1px 10px rgba(0, 0, 0, 0.5);
    &-mobile {
      border-radius: unset !important;
      background-color: white !important;
    }
    &-inner {
      border: none  !important;
      border-radius: 4px;
      background-color: white  !important;
    }
    &-top {
      border-top-left-radius: 4px;
      border-top-right-radius: 4px;
      background-color: white  !important;
      padding: 0 10px 0 ;
      margin-top: 8px;
    }
    &-caption {
      display: none !important;
    }
    &-close {
      width: 24px !important;
      background-image: none !important;
      &::before {
        content: "x";
        font-size: 40px;
        color: #09F;
        font-weight: 100;
        display: inline-block;
      }
    }
  }
  .gigya-login-form .gigya-composite-control.gigya-composite-control-header.custom-h2 {
    position: relative;
    visibility: hidden;
    &::before {
      position: absolute;
      content: "Sign In";
      visibility: visible;
    }
  }
  .gigya-login-form, .gigya-reset-password-form, .gigya-register-form {
    h2 {
      font-size: 28px !important;
    }
    .or-line.center-content.vspacer2 {
      border-top: 1px solid #e0e0e0 !important;
      .block {
        background-color: white !important;
        width: 34px !important;
        font-weight: 500 !important;
      }
    }
    label {
      text-transform: uppercase;
      span {
        color: #003594 !important;
        a {
          color: darken(#09F, 8) !important;
          font-size: 12px;
          text-transform: capitalize;
          font-family: 'Libre Franklin', sans-serif;
        }
      }
    }
    input {
      border: 1px solid #09F !important;
      &:focus {
        box-shadow: 0 0 1px 1px #09F;
      }
    }
    .gigya-composite-control.gigya-composite-control-submit input {
      width: 125px !important;
      height: 50px;
      background-color: lighten(#ff483e, 2) !important;
      font-weight: 400;
      font-size: 15px;
      border: none !important;
      &:focus {
        box-shadow: none !important;
        outline: 0;
      }
      &:hover {
        background-color: darken(#ff483e, 1) !important;
      }
    }
  }
  .gigya-composite-control.gigya-composite-control-label {
    text-transform: none;
    color: darken(grey, 8);
    font-family: 'Libre Franklin', sans-serif;
    a {
      color: darken(#09F, 10) !important;
      text-transform: capitalize;
    }
  }
  .gigya-reset-password-form {
    div:nth-child(1) {
      > .gigya-composite-control.gigya-spacer {
        position: relative;
        &::before {
          position: absolute;
          content: "Forgot Password";
          font-size: 28px;
          left: calc(50% - 108px)
        }
      }
    }
    div:nth-child(2) {
      > label {
        margin-top: 22px;
        font-size: 15px;
        font-weight: 600;
        text-align: center;
        color: black;
      }
    }
    div:nth-child(3) {
      width: 100%;
      > div:first-child {
        display: none !important;
      }
      div + div {
        max-width: 100% !important;
        float: unset !important;
        margin-top: 10px;
      }
    }
    div:nth-child(5) {
      > div:first-child {
        display: none !important;
      }
      label {
        text-align: center !important;
        font-family: "Libre Franklin", sans-serif;
        a {
          text-transform: lowercase !important;
        }
      }
    }
  }
  .gigya-register-form .gigya-composite-control.gigya-composite-control-submit input {
    width: 180px !important;
  }
  .gigya-register-form .gigya-composite-control.gigya-composite-control-label.custom-center a {
    &::before {
      position: absolute;
      content: "Sign In";
      visibility: visible;
      background-color: white;
      text-decoration: underline;
    }
  }
`

const ClassName = 'ReactModal'
const ReactModal = css`
  .${ClassName}__Overlay {
    opacity: 0;
    transition: opacity 400ms ease;
    background-color: rgba(0, 0, 0, 0.5) !important;
    &--after-open {
      opacity: 1;
    }
  }
  .${ClassName}__Content {
    display: flex;
    flex-direction: column;
    border: none !important;
    ${maxWidth.medium`
      max-height: 95%;
    `}
    h4 {
      margin-top: 0;
    }
    h4, p {
      text-align: center;
    }
    p {
      font-size: 18px;
    }
    ul {
      list-style-type: none;
      margin: 10px auto;
      display: inline-block;
      li {
        text-align: left;
      }
    }
  }
  .${ClassName}__submit-buttons button {
    margin: 15px !important;
  }
  .${ClassName}__button-close {
    float: right;
    cursor: pointer;
    background: transparent;
    border: none;
    outline: 0;
    svg {
      height: 24px;
      width: 24px;
      fill: ${props => props.theme.colors.mercuryBlue};
    }
  }
`

export default createGlobalStyle`
  ${ResetStyles};
  ${DefaultStyles};
  ${Gigya};
  ${ReactModal};
`